/**
 * 格式化文件大小（字节转KB/MB/GB）
 * @param {Number} bytes - 文件大小（字节）
 * @returns {String} 格式化后的大小（如：1.23 MB）
 */
 export function formatFileSize(bytes) {
  // 处理无效值
  if (!bytes || bytes < 0) return '0 B'
  
  // 单位数组
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  // 计算单位索引
  let unitIndex = 0
  let size = bytes
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  }
  
  // 保留两位小数并拼接单位
  return `${size.toFixed(2)} ${units[unitIndex]}`
}

/**
 * 格式化日期时间（如：2024-05-20 14:30:00）
 * @param {String|Date} date - 日期字符串或Date对象
 * @param {String} format - 格式模板（默认：yyyy-MM-dd HH:mm:ss）
 * @returns {String} 格式化后的日期时间
 */
export function formatDateTime(date, format = 'yyyy-MM-dd HH:mm:ss') {
  // 处理无效日期
  if (!date) return ''
  
  // 转换为Date对象（处理ISO格式字符串，如 "2024-05-20T12:00:00.000Z"）
  if (typeof date === 'string') {
    date = date.replace('T', ' ').replace(/\.\d{3}Z$/, '') // 去除ISO格式中的T和毫秒后缀
    date = new Date(date)
  }
  
  // 检查日期有效性（避免Invalid Date）
  if (isNaN(date.getTime())) return ''
  
  // 提取日期时间各部分
  const o = {
    'M+': date.getMonth() + 1,        // 月份（1-12，需补0）
    'd+': date.getDate(),             // 日（1-31，需补0）
    'H+': date.getHours(),            // 时（0-23，需补0）
    'm+': date.getMinutes(),          // 分（0-59，需补0）
    's+': date.getSeconds(),          // 秒（0-59，需补0）
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度（1-4）
    'S': date.getMilliseconds()       // 毫秒（0-999，无需补0）
  }
  
  // 处理年份（支持1-4位年份，如 yyyy -> 2024，yy -> 24）
  if (/(y+)/.test(format)) {
    const yearStr = date.getFullYear() + ''
    format = format.replace(RegExp.$1, yearStr.substr(4 - RegExp.$1.length))
  }
  
  // 处理月份、日、时、分、秒（补0逻辑，如 M -> 5，MM -> 05）
  for (const k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      const valueStr = o[k] + ''
      // 若格式模板中是两位（如 MM），则补0；一位（如 M）则直接显示
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? valueStr : (`00${valueStr}`).substr(valueStr.length)
      )
    }
  }
  
  return format
}

/**
 * 格式化时间戳（毫秒转日期时间）
 * @param {Number} timestamp - 时间戳（毫秒）
 * @param {String} format - 格式模板
 * @returns {String} 格式化后的日期时间
 */
export function formatTimestamp(timestamp, format = 'yyyy-MM-dd HH:mm:ss') {
  if (!timestamp || typeof timestamp !== 'number') return ''
  return formatDateTime(new Date(timestamp), format)
}